export const COLORS = {
  // Brand / Key
  primary: "#000000",
  primaryVariant: "#222222",
  secondary: "#ffffff",
  secondaryVariant: "#dddddd",
  tertiary: "#888888", // optional accent in gray

  // Background & Surfaces
  background: "#ffffff",
  surface: "#ffffff",
  surfaceVariant: "#f2f2f2",
  inverseSurface: "#000000",

  // Text / Foreground
  text: "#000000",
  textSecondary: "#4a4a4a",
  textDisabled: "#9e9e9e",
  textLight: "#ffffff",
  onPrimary: "#ffffff",
  onSecondary: "#000000",
  onTertiary: "#000000",
  onBackground: "#000000",
  onSurface: "#000000",
  inverseOnSurface: "#ffffff",
  onError: "#ffffff",

  // Feedback / Status (grayscale equivalents)
  error: "#cc0000",
  warning: "#888888",
  success: "#444444",
  info: "#222222",
  loading: "#0000ff",

  // Borders / Dividers
  border: "#eeeeee",
  borderDark: "#dddddd",
  outline: "#bdbdbd",
  divider: "#e0e0e0",

  // States
  hover: "rgba(0, 0, 0, 0.04)",
  pressed: "rgba(0, 0, 0, 0.08)",
  focused: "rgba(0, 0, 0, 0.12)",
  disabled: "rgba(0, 0, 0, 0.38)",

  // Other
  shadow: "rgba(0, 0, 0, 0.2)",
  highlight: "rgba(0, 0, 0, 0.1)",
  link: "#000000",
  selection: "rgba(0, 0, 0, 0.2)",
};
